import React from "react";
import { MenuItem, Nav, Navbar, NavDropdown, NavItem } from "react-bootstrap";
import { IndexLink } from "react-router";
import { IndexLinkContainer, LinkContainer } from "react-router-bootstrap";

export default function Navigation(props) {
  return (
    <Navbar>
      <Navbar.Header>
        <Navbar.Brand>
          <IndexLink to="/">Matteri Vineyards</IndexLink>
        </Navbar.Brand>
        <Navbar.Toggle />
      </Navbar.Header>
      <Navbar.Collapse>
        <Nav>
          <IndexLinkContainer to="/">
            <NavItem>Home</NavItem>
          </IndexLinkContainer>
          <LinkContainer to="/about" onClick={event => event.preventDefault()}>
            <NavDropdown id="mv-nav-about-dropdown" title="About" eventKey="1">
              <LinkContainer to="/about/our_vineyard">
                <MenuItem>Our Vineyard</MenuItem>
              </LinkContainer>
              <LinkContainer to="/about/who_we_are">
                <MenuItem>Who We Are</MenuItem>
              </LinkContainer>
              <LinkContainer to="/about/vineyard_profile">
                <MenuItem>Vineyard Profile</MenuItem>
              </LinkContainer>
              <LinkContainer to="/about/wineries">
                <MenuItem>Wineries</MenuItem>
              </LinkContainer>
            </NavDropdown>
          </LinkContainer>
          <LinkContainer
            to="/history"
            onClick={event => event.preventDefault()}
          >
            <NavDropdown id="mv-nav-history-dropdown" title="History">
              <LinkContainer to="/history/vineyard_creation">
                <MenuItem>Creation of the Vineyard</MenuItem>
              </LinkContainer>
              <LinkContainer to="/history/planting_history">
                <MenuItem>Planting History</MenuItem>
              </LinkContainer>
            </NavDropdown>
          </LinkContainer>
          <LinkContainer
            to="/pictures"
            onClick={event => event.preventDefault()}
          >
            <NavDropdown id="mv-nav-pictures-dropdown" title="Pictures">
              <LinkContainer to="/pictures/vineyard_views">
                <MenuItem>Vineyard Views</MenuItem>
              </LinkContainer>
              <LinkContainer to="/pictures/vineyard_people">
                <MenuItem>Vineyard People</MenuItem>
              </LinkContainer>
              <LinkContainer to="/pictures/development_and_planting/2010">
                <MenuItem>Development and Planting</MenuItem>
              </LinkContainer>
            </NavDropdown>
          </LinkContainer>
          <LinkContainer to="/weather">
            <NavItem>Weather</NavItem>
          </LinkContainer>
          <LinkContainer to="/contact">
            <NavItem>Contact</NavItem>
          </LinkContainer>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}



// WEBPACK FOOTER //
// ./src/components/Nav.jsx